import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { VerificationData } from 'ng-voxloud/lib/vd-table-readonly/vd-table-readonly.model';

@Component({
  selector: 'gdp-verification-data-label',
  template:`
    <div class="d-flex justify-content-between" *ngIf="vd">
      <span>{{label}}</span>
      <span [class]="chipClass">{{vd.type}}</span>
    </div>
  `,
  styleUrls: ['verification-data-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VerificationDataLabelComponent implements OnInit {
  @Input('vd') vd: VerificationData;
  private classMap = {
    BUSINESS: 'vox-chip vox-chip_royal-blue-text',
    PRIVATE: 'vox-chip vox-chip_bright-crimson-text'
  }
  constructor() { }

  ngOnInit(): void {
  }

  public get chipClass():string {
    return this.classMap[this.vd.type] || ''
  }

  public get label():string {
    if (this.vd.type === 'PRIVATE') {
      return this.vd.label
        ? `${this.vd.label} - ${this.vd.first_name}  ${this.vd.last_name}`
        : `${this.vd.first_name}  ${this.vd.last_name}`;
    }

    if (this.vd.type === 'BUSINESS') {
      return this.vd.label
        ? `${this.vd.label} - ${this.vd.company_name}`
        : `${this.vd.company_name}`
    }

    return '';
  }

}
